customElements.define(
  "map-container",
  class extends HTMLElement {
    constructor() {
      super();
      this.map = null;

      this.mapWidth = this.clientWidth;
      this.mapHeight = this.clientHeight;
      this.boxView = "landscape";
      this.boxBorder = 3;

      this.box = this.querySelector("#box");
      this.instructions = this.querySelector(".instructions");

      // Close Instructions logic
      if (
        this.instructions &&
        this.instructions.querySelector(".instructions__close")
      ) {
        this.instructions
          .querySelector(".instructions__close")
          .addEventListener("click", this.closeInstructions);
      }

      // Close Map logic
      this.mapClose = this.querySelector(".map__close");
      if (this.mapClose) {
        this.mapClose.addEventListener("click", this.closeMap);
      }

      // View Changer logic
      this.querySelector(".view-changer")?.addEventListener(
        "change",
        this.changeView,
      );

      this.setAttribute("box-view", this.boxView);

      this.ACCESS_TOKEN =
        "pk.eyJ1IjoiZ2V0Z2lmdHl3aXRoaXQiLCJhIjoiY21reWduNHE1MDZnbTNkcTljdG03Y2hqbCJ9.jYRkfMr79zvPXIG29fuZiA";
      mapboxgl.accessToken = this.ACCESS_TOKEN;

      this.initializeMap();

      this.captureButton = this.querySelector("#Capture");
      this.captureButton?.addEventListener("click", async () => {
        await this.captureArea();
        this.showPreview();
      });

      document.querySelector("html")?.classList.add("overflow-hidden");
    }

    showPreview = () => {
      if (!this.imageUrl) return;
      const imageEl = document.createElement("img");
      imageEl.src = this.imageUrl;
      imageEl.style.width = "100%";
      imageEl.style.height = "100%";
      imageEl.style.objectFit = "cover";
      document
        .querySelector(".buy-buttons-block")
        ?.parentElement?.insertBefore(
          imageEl,
          document.querySelector(".buy-buttons-block"),
        );
    };

    closeInstructions = () => {
      if (this.instructions) this.instructions.style.display = "none";
    };

    changeView = (e) => {
      // Look for the value of the checked radio button
      const view = e.target.value;
      if (view) {
        this.boxView = view;
        this.setAttribute("box-view", this.boxView);
      }
    };

    closeMap = () => {
      document.querySelector("html")?.classList.remove("overflow-hidden");
      const section = document.querySelector(
        `#${this.getAttribute("section-id")}`,
      );
      if (section) section.style.display = "none";
    };

    initializeMap = () => {
      this.map = new mapboxgl.Map({
        container: "map",
        style: "mapbox://styles/mapbox/streets-v11",
        // style: "mapbox://styles/getgiftywithit/cm18rwbfq00af01pccvvz4nkt",
        // style: "mapbox://styles/getgiftywithit/cm19ev8ui02al01pbasdx28hc",

        bounds: [
          [-74.2709, 40.48972],
          [-73.7042, 40.93288],
        ],
        fitBoundsOptions: { padding: 15 },
      });

      // 1. Initialize the Geocoder
      const geocoder = new MapboxGeocoder({
        accessToken: this.ACCESS_TOKEN,
        mapboxgl: mapboxgl,
        marker: false, // Prevents default marker if you don't want it
      });

      // 2. Instead of map.addControl, we append it to our custom container
      // This pulls the search bar out of the map's z-index hierarchy
      const geocoderContainer = document.getElementById("geocoder-container");
      if (geocoderContainer) {
        geocoderContainer.appendChild(geocoder.onAdd(this.map));
      } else {
        // Fallback if container isn't found
        this.map.addControl(geocoder);
      }
    };

    captureArea = async () => {
      this.boxWidth = this.querySelector("#box")?.clientWidth ?? 0;
      this.boxHeight = this.querySelector("#box")?.clientHeight ?? 0;

      const boxRect = this.box.getBoundingClientRect();

      const topLeftBoxCorner = {
        x: boxRect.x + this.boxBorder,
        y: boxRect.y + this.boxBorder,
      };

      const bottomRightBoxCorner = {
        x: topLeftBoxCorner.x + this.boxWidth,
        y: topLeftBoxCorner.y + this.boxHeight,
      };

      const topLeft = this.map.unproject([
        topLeftBoxCorner.x,
        topLeftBoxCorner.y,
      ]);
      const bottomRight = this.map.unproject([
        bottomRightBoxCorner.x,
        bottomRightBoxCorner.y,
      ]);

      const imageDimensions = `${this.boxWidth * 2}x${this.boxHeight * 2}`;
      const res = await fetch(
        `https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/[${topLeft.lng}, ${bottomRight.lat},${bottomRight.lng}, ${topLeft.lat}]/${imageDimensions}?access_token=${this.ACCESS_TOKEN}`,
      );

      const blob = await res.blob();
      this.imageUrl = URL.createObjectURL(blob);
      this.closeMap();

      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.name = "properties[image]";
      fileInput.accept = "image/*";
      fileInput.style.display = "none";
      const myFile = new File([blob], "image.jpg", { type: "image/jpeg" });
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(myFile);
      fileInput.files = dataTransfer.files;

      const form = document.querySelector(
        `.product-details form.shopify-product-form[action="/cart/add"]`,
      );
      if (form) form.prepend(fileInput);
    };
  },
);
